import type { PropsWithChildren } from "react";

import { Trophy } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { LegendWithOneLineBulletFlex } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { ILegendItem } from "./types";

export const DomainLegendItem = ({
    item,
    children,
    showTrophy = false,
    fontVariant = "body2",
    dataAutomation,
}: PropsWithChildren<{
    item: ILegendItem;
    showTrophy?: boolean;
    fontVariant?: "body2" | "subtitle2";
    dataAutomation: string;
}>) => (
    <LegendWithOneLineBulletFlex
        text={
            <Flex
                alignItems="center"
                gap="4px"
                alignContent="center"
            >
                <Text
                    as="a"
                    href={`https://${item.name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    fontVariant={fontVariant}
                >
                    {children}
                </Text>
                {showTrophy ? (
                    <Trophy
                        size="xs"
                        color={colorsPalettes.yellow[400]}
                    />
                ) : null}
            </Flex>
        }
        labelColor={item.color}
        dataAutomation={dataAutomation}
    />
);
